/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ConfirmSignupDto } from '../../models/confirm-signup-dto';
import { ConfirmSignupResponseDto } from '../../models/confirm-signup-response-dto';

export interface ConfirmSignup$Params {
  body: ConfirmSignupDto;
}

export function confirmSignup(
  http: HttpClient,
  rootUrl: string,
  params: ConfirmSignup$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ConfirmSignupResponseDto>> {
  const rb = new RequestBuilder(rootUrl, confirmSignup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConfirmSignupResponseDto>;
      }),
    );
}

confirmSignup.PATH = '/auth/signup/confirm';
